import PropTypes from 'prop-types';

import {
  DELETE_SHIP_ADDRESS,
  EDIT_SHIP_ADDRESS,
  SHIP_TO_THIS_ADDRESS
} from 'constants/checkoutButtons';

import { Row, RowSpan } from 'components/checkout/caap/Layout';
import {
  column as styleColumn,
  last as styleLast,
  row as styleRow
} from 'styles/components/checkout/caap/layout.scss';
import styles from 'styles/components/checkout/caap/address/addresslist/shippingButtons.scss';

const ShippingButtons = (componentParams, { testId }) => {
  const {
    addressId,
    isFetchingCheckoutData,
    onDeleteAddressClick,
    onEditAddressClick,
    onUseThisAddressClick
  } = componentParams;

  const deleteAddressId = `${DELETE_SHIP_ADDRESS}-${addressId}`;

  return (
    <div className={styleRow}>
      <button
        type="button"
        className={styles.checkoutPrimaryButton}
        data-test-id={testId('useThisShippingAddress')}
        disabled={isFetchingCheckoutData}
        id={`${SHIP_TO_THIS_ADDRESS}-${addressId}`}
        onClick={() => onUseThisAddressClick(addressId)}>
        Ship to this address
      </button>

      <Row mobileOnly={true}>
        <RowSpan span="6">
          <div className={styleColumn}>
            <button
              className={styles.checkoutSecondaryButton}
              data-edit-address-id={addressId}
              data-test-id={testId('editShippingAddress')}
              id={`${EDIT_SHIP_ADDRESS}-${addressId}`}
              onClick={() => onEditAddressClick(addressId)}
              type="button">
              Edit
            </button>
          </div>
        </RowSpan>
        <RowSpan span="6">
          <div className={`${styleColumn} ${styleLast}`}>
            <button
              className={styles.checkoutSecondaryButton}
              data-test-id={testId('deleteShippingAddress')}
              id={deleteAddressId}
              onClick={() => onDeleteAddressClick(addressId)}
              type="button">
              Delete
            </button>
          </div>
        </RowSpan>
      </Row>
    </div>
  );
};

ShippingButtons.contextTypes = {
  testId: PropTypes.func
};

export default ShippingButtons;
